// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://quidbuzjosjewriszapj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF1aWRidXpqb3NqZXdyaXN6YXBqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUwNTQ2MTksImV4cCI6MjA3MDYzMDYxOX0.sULaqVfSKlgmdensRRuS2GSH4Sb5MXBEmHUitNrtI4Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 2,
    },
  },
  global: {
    headers: {
      'x-client-info': 'lexsavvy-web',
    },
  },
});